import { useQuery } from '@tanstack/react-query';

import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export type CommunityActivity = {
  id: number;
  community_id: number;
  actor_id: string | null;
  type: string;
  action: string;
  target_type: string | null;
  target_id: string | null;
  metadata: Record<string, unknown> | null;
  created_at: string;
  community: {
    name: string;
  };
};

export type ApiResponse_Get_Community_Activities = CommunityActivity[];

const METHOD = 'GET';
const ENDPOINT = 'communities/{id}/activities';

export const QUERY_KEY = (params: { communityId: number }) => [
  'community',
  'activities',
  params.communityId,
];

export const useGetCommunityActivities = (
  params: { communityId: number },
  enabled = true
) => {
  const { session } = useAuth();

  return useQuery({
    queryKey: QUERY_KEY(params),
    enabled: enabled && !!session && !!params.communityId,
    queryFn: async () => {
      const data = await handleApiCall<ApiResponse_Get_Community_Activities>(
        session,
        METHOD,
        getResolvedEndpoint(ENDPOINT, { id: params.communityId.toString() })
      );

      return data;
    },
  });
};